import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { GetNtxPeoplesList } from '../../../store/NTX/Peoples/peoplesSlice';
import useGetOrganizations from '../../../hooks/HR/use-get-organizations';
import { GetEquipmentsModelList } from '../../../store/FLEET/EquipmentsModel/equipmentsmodelSlice';
import { GetEngineStatues } from '../../../store/Lookup/lookupSlice';
import useGetPeoplesList from '@hooks/NTX/useGetPeoplesList';
import { GetEquipmentsById } from '@store/FLEET/Equipments/equipmentsSlice';
import Loading from '@components/Shared/Loader/Loading';
import ExtraInformationBuilderUpdate from '../../ExtraInformation/ExtraInformationBuilder/Update/ExtraInformationBuilderUpdate';

// تعريف نوع البيانات للمعدة باستخدام TypeScript (اختياري)
interface EquipmentDetailsProps {
  Id: string;
}

const EquipmentDetails: React.FC<EquipmentDetailsProps> = ({ Id }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const { DriversList } = useGetPeoplesList({ LookupType: '' });
  const { Organizations } = useGetOrganizations();

  useEffect(() => {
    dispatch(GetNtxPeoplesList(''));
    dispatch(GetEquipmentsModelList());
    dispatch(GetEngineStatues());
    if (Id) {
      dispatch(GetEquipmentsById(Id));
    }
  }, []);
  const { EquipmentsById: equipment, loadingById, errorById } = useAppSelector(state => state.Equipments);
  const { EngineStatues } = useAppSelector(state => state.Lookup);
  const { EquipmentsModelList } = useAppSelector(state => state.EquipmentsModel);

  console.log(equipment);

  // دالة للحصول على اسم الموديل بناءً على fleetModelId
  const getModelName = (id: string) => {
    const model = EquipmentsModelList.find(item => item.id === id);
    return model ? (i18n.language === 'ar' ? model.name2 : model.name) : '-';
  };

  // دالة للحصول على حالة المحرك
  const getEngineStatus = (code: string) => {
    let status = '-';
    EngineStatues.forEach((item: any) => {
      const found = item.list.find((listItem: any) => listItem.lookupCode === code);
      if (found) {
        status = i18n.language === 'ar' ? found.meaning2 : found.meaning;
      }
    });
    return status;
  };

  // دالة للحصول على اسم المنظمة
  const getOrganizationName = (id: string) => {
    const org = Organizations.find((item: any) => item.id === id && item.type === '150');
    return org ? (i18n.language === 'ar' ? org.name2 : org.name) : '-';
  };

  // دالة للحصول على اسم المالك أو السائق
  const getPersonName = (id: string, type: 'OWNERS' | 'DRIVERS') => {
    const person = DriversList.find(item => item.id === id && item.typeCode === type);
    return person ? (i18n.language === 'ar' ? person.name2 : person.name) : '-';
  };

  return (
    <>
      <Loading loading={loadingById} error={errorById}>
        <div className='container'>
          <div className='row'>
            {/* المعلومات الأساسية */}
            <div className='col-xl-2 mb-3'>
              <label className='form-label'>{t('AssetNumber')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>{equipment?.code || '-'}</div>
            </div>

            <div className='col-xl-5 mb-3'>
              <label className='form-label'>{t('LocalName')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>{equipment?.name2 || '-'}</div>
            </div>

            <div className='col-xl-5 mb-3'>
              <label className='form-label'>{t('GlobalName')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>{equipment?.name || '-'}</div>
            </div>

            {/* الموديل */}
            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Model')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>
                {getModelName(equipment?.fleetModelId || '')}
              </div>
            </div>

            {/* تفاصيل التعريف الفنية */}
            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Plate_Number')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>{equipment?.plateNo || '-'}</div>
            </div>

            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Serial_Number')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>{equipment?.serialNo || '-'}</div>
            </div>

            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Chassis_Number')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>{equipment?.chassisNo || '-'}</div>
            </div>

            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Barcode')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>{equipment?.barcode || '-'}</div>
            </div>

            {/* حالة المعدة */}
            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Engine_Status')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>
                {getEngineStatus(equipment?.engineStatus || '')}
              </div>
            </div>

            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Odometer')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>{equipment?.odometer || '-'}</div>
            </div>

            {/* الإدارة */}
            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Branch')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>
                {getOrganizationName(equipment?.organizationId || '')}
              </div>
            </div>

            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Owner')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>
                {getPersonName(equipment?.ownerId || '', 'OWNERS')}
              </div>
            </div>

            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Driver')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>
                {getPersonName(equipment?.driverId || '', 'DRIVERS')}
              </div>
            </div>

            {/* التواريخ */}
            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('ServiceDate')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>
                {equipment?.serviceDate?.split('T')[0] || '-'}
              </div>
            </div>

            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('dateOfExpiry')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>
                {equipment?.dateOfExpiry?.split('T')[0] || '-'}
              </div>
            </div>

            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('LastMaintenanceDate')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>
                {equipment?.lastmaintenanceDate?.split('T')[0] || '-'}
              </div>
            </div>

            {/* السعر */}
            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Purchase_Price')}</label>
              <div className='form-control-plaintext border rounded-3 p-2'>{equipment?.purchasePrice || '-'}</div>
            </div>

            {/* صورة المعدة */}
            <div className='col-xl-3 mb-3'>
              <label className='form-label'>{t('Equipment_Image')}</label>
              <div className='border p-2'>
                {equipment?.image ? (
                  <img src={equipment.image.filePath} alt='equipment' className='img-fluid rounded' />
                ) : (
                  <span>-</span>
                )}
              </div>
            </div>
          </div>

          <div className='rounded-2 p-3 mb-3 border border-theme'>
            <div className='d-flex align-items-center mb-3'>
              <i className='fa fa-info-circle fa-lg text-theme me-2'></i>
              <h5 className='mb-0'>{t('ExtraInformation')}</h5>
            </div>

            {equipment?.extraInformationId && (
              <ExtraInformationBuilderUpdate
                extraInformationId={equipment?.extraInformationId}
                //   referenceId={''}
                setExtraInfoFormData={() => null}
              />
            )}
          </div>
        </div>
      </Loading>
    </>
  );
};

export default EquipmentDetails;
